import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, Input, Self } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash';
import { DatesService } from 'src/app/shared/services/dates.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-rutas-camion',
  templateUrl: './modal-rutas-camion.component.html',
  styleUrls: ['../ruteador.component.scss'],
  providers: [SecurityService],
})
export class ModalRutasCamionComponent implements OnInit, OnDestroy {
  @ViewChild('verRutasCamionModal', { static: true }) verRutasCamionModal: ModalDirective;
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCerrar: EventEmitter<number> = new EventEmitter<number>();
  numeroRutaActual: number | null = null; // Guardar el número de ruta actual
  origenPersonalizado: any = null; // Guardar el origen personalizado (para rutas divididas)

  formRuta: FormGroup;

  recorridoSeleccionado: any = null;
  optionsChofer: Array<any> = [];
  optionsCamion: Array<any> = [];
  beaches_rutas = [];
  puntosRuta = []; // Array para los marcadores personalizados
  puntosDuplicados = []; // Array para mostrar información de puntos duplicados en el footer
  hayPrioridadesEnRuta = false; // Variable para saber si hay prioridades en la ruta actual
  private routeCalculationTimeout: any; // Para controlar el timeout del cálculo de ruta

  //Variables
  public rutEmpresa;
  public sucursalCodigo;
  public latitudEmpresa;
  public longitudEmpresa;
  loading: boolean;
  public directionsService: any;
  public directionsRenderer: any;
  globalMap_rutas: any;
  private infoWindows: any[] = [];

  // Utils
  private log: any

  //Oculta elementos del mapa
  public customStyle = [{
    "featureType": "poi.medical", //Hospitales y Clinicas
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  },
  {
    "featureType": "poi.business", //Negocios
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  }, {
    "featureType": "poi.park", //Parques
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  }, {
    "featureType": "poi.sports_complex", //Complejos Deportivos
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  }, {
    "featureType": "poi.school", //Escuelas
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  }, {
    "featureType": "poi.attraction", //Sitios Turisticos y Atrasiones
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  }, {
    "featureType": "poi.place_of_worship", //Monasterios Iglesias
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  }, {
    "featureType": "poi.government", //Centrol Gubernamentales
    "elementType": "all",
    "stylers": [{
      visibility: "off",
    },]
  },];

  constructor(
    private fb: FormBuilder,
    private clog: ConsoleService,
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
  ) {
    this.log = this.clog.log('RUTEADOR ADD EDIT')
  }

  ngOnInit() {
    this.createForm();
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
    this.latitudEmpresa = this.accesolocalstorage.getLatitudEmpresa();
    this.longitudEmpresa = this.accesolocalstorage.getLongitudEmpresa();
  }

  ngOnDestroy() {
    console.log('🧹 Destruyendo componente - liberando recursos...');

    // Cancelar timeout si está activo
    if (this.routeCalculationTimeout) {
      clearTimeout(this.routeCalculationTimeout);
      this.routeCalculationTimeout = null;
    }

    // Limpiar DirectionsRenderer
    if (this.directionsRenderer) {
      try {
        this.directionsRenderer.setDirections({ routes: [] });
        this.directionsRenderer.setMap(null);
        this.directionsRenderer = null;
      } catch (error) {
        console.warn('⚠️ Error limpiando DirectionsRenderer en destroy:', error);
      }
    }

    // Limpiar solo arrays generados internamente
    this.puntosRuta = [];
    this.puntosDuplicados = [];
    // NO limpiar this.beaches_rutas porque son datos del componente padre

    console.log('✅ Recursos liberados completamente');
  }

  private createForm() {
    this.formRuta = this.fb.group({
      chofer: [''],
      camion: [''],
      negocio: [''],
      nroDoc: [''],
      monto: [''],
      fechaMain: [null],
    });

  }

  loadAndShow(beachesRutas: any, numeroRuta?: number, origenPersonalizado?: any) {
    this.clearModal();
    this.beaches_rutas = beachesRutas;
    this.numeroRutaActual = numeroRuta || null; // Guardar el número de ruta si se proporciona
    this.origenPersonalizado = origenPersonalizado || null; // Guardar el origen personalizado si se proporciona
    this.generarPuntosRuta(); // Generar los puntos con información de documentos
    this.verRutasCamionModal.show();
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);
  }

  clearModal() {
    console.log('🧹 Limpiando modal y liberando recursos...');

    // 1. Limpiar formulario
    this.formRuta.reset();

    // 2. Cerrar todos los InfoWindows
    this.puntosRuta.forEach(punto => {
      punto.infoWindowAbierto = false;
    });

    // 3. Limpiar array de puntos generados (pero NO los datos originales)
    this.puntosRuta = [];
    this.puntosDuplicados = [];
    // NO limpiar this.beaches_rutas porque son los datos del componente padre

    // 4. Cancelar timeout de cálculo de ruta si está activo
    if (this.routeCalculationTimeout) {
      clearTimeout(this.routeCalculationTimeout);
      this.routeCalculationTimeout = null;
      console.log('✅ Timeout de cálculo de ruta cancelado');
    }

    // 5. Limpiar ruta del DirectionsRenderer (pero mantener el renderer activo)
    if (this.directionsRenderer) {
      try {
        this.directionsRenderer.setDirections({ routes: [] });
        console.log('✅ Ruta limpiada del DirectionsRenderer');
      } catch (error) {
        console.warn('⚠️ Error limpiando ruta del DirectionsRenderer:', error);
      }
    }

    // 6. Resetear variables de estado
    this.hayPrioridadesEnRuta = false;

    // 7. Emitir evento de cierre si hay un número de ruta
    if (this.numeroRutaActual !== null) {
      this.onCerrar.emit(this.numeroRutaActual);
      this.numeroRutaActual = null;
    }

    // 8. Limpiar origen personalizado
    this.origenPersonalizado = null;

    console.log('✅ Modal limpiado completamente');
  }

  // Generar puntos de ruta con información de documentos
  generarPuntosRuta() {
    this.puntosRuta = [];
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    console.log('=== DATOS DE BEACHES_RUTAS ===');
    console.log('beaches_rutas:', this.beaches_rutas);

    this.beaches_rutas.forEach((beach, index) => {
      console.log(`Beach ${index}:`, beach);

      const numerosDocumento = beach[5] || 'Sin número';
      const direccion = beach[0];
      const comuna = beach[6];
      const prioridad = beach[4] || 0;

      console.log(`  - N° Doc: ${numerosDocumento}`);
      console.log(`  - Dirección: ${direccion}`);
      console.log(`  - Comuna: ${comuna}`);
      console.log(`  - Prioridad: ${prioridad}`);

      // Crear punto sin asignar letra aún (se asignará después de la optimización)
      this.puntosRuta.push({
        lat: parseFloat(beach[1]),
        lng: parseFloat(beach[2]),
        numerosDocumento: numerosDocumento,
        direccion: direccion,
        comuna: comuna,
        cantidadDocumentos: 1,
        iconUrl: '', // Se asignará después
        infoWindowAbierto: false,
        prioridad: prioridad,
        indexOriginal: index // Guardar el índice original
      });
    });

    console.log('✅ Puntos de ruta generados:', this.puntosRuta.length);
  }

  // Función para asignar letras a los puntos según su posición final
  private asignarLetrasAPuntos() {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    console.log('🔄 Asignando letras a los puntos según su posición final...');

    this.puntosRuta.forEach((punto, index) => {
      // Asignar letra según la posición final (A es origen, B, C, D, etc. son destinos)
      // Como el punto de origen (empresa) no está en puntosRuta, los destinos empiezan desde B
      const letra = alphabet[index + 1] || (index + 2).toString(); // +1 porque A es el origen
      const color = punto.prioridad > 0 ? 'FF0000' : '0066CC';
      const iconUrl = `https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=${letra}|${color}`;

      punto.iconUrl = iconUrl;

      console.log(`✅ Punto ${index}: ${letra} - ${punto.direccion} - Prioridad: ${punto.prioridad}`);
    });

    console.log('✅ Letras asignadas correctamente');

    // Actualizar el footer con la información de puntos duplicados
    this.actualizarPuntosDuplicadosFooter();
  }

  // Función para reordenar los puntos según la optimización
  private reordenarPuntosSegunOptimizacion(optimizedDestinations: any[]) {
    console.log('🔄 Reordenando puntos según optimización...');

    const puntosReordenados = [];

    // Reordenar los puntos según el orden optimizado
    optimizedDestinations.forEach((dest, index) => {
      // Encontrar el punto original por su índice original
      const puntoOriginal = this.puntosRuta.find(p => p.indexOriginal === dest.index);
      if (puntoOriginal) {
        puntosReordenados.push({ ...puntoOriginal });
      }
    });

    // Actualizar el array de puntos
    this.puntosRuta = puntosReordenados;

    console.log('✅ Puntos reordenados según optimización');
    console.log('Orden final:', this.puntosRuta.map((p, i) => `${i}: ${p.direccion}`));

    // Asignar letras después del reordenamiento
    this.asignarLetrasAPuntos();
  }

  // Función para abrir InfoWindow de un marcador específico
  abrirInfoWindow(index: number) {
    console.log('Abriendo InfoWindow para punto:', index, this.puntosRuta[index]);

    // Cerrar todos los InfoWindows abiertos
    this.puntosRuta.forEach(punto => {
      punto.infoWindowAbierto = false;
    });

    // Abrir el InfoWindow del marcador seleccionado
    if (this.puntosRuta[index]) {
      this.puntosRuta[index].infoWindowAbierto = true;
      console.log('✅ InfoWindow abierto para N° Doc:', this.puntosRuta[index].numerosDocumento);
    }
  }

  // Función para cerrar InfoWindows
  closeInfoWindows() {
    this.infoWindows.forEach(infoWindow => {
      if (infoWindow && typeof infoWindow.close === 'function') {
        try {
          infoWindow.close();
        } catch (error) {
          console.warn('Error al cerrar InfoWindow:', error);
        }
      }
    });
    this.infoWindows = [];
  }

  // Función para reordenar los puntos según el orden optimizado de Google Maps
  reordenarPuntosSegunRutaOptimizada(waypointOrder: number[]) {
    console.log('🔄 Reordenando puntos según ruta optimizada...');
    console.log('waypoint_order:', waypointOrder);
    console.log('puntosRuta antes:', this.puntosRuta.map((p, i) => `${i}: ${p.direccion}`));

    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const puntosReordenados = [];

    if (this.puntosRuta.length === 0) return;

    // Google Maps estructura:
    // - Origen: Empresa (no aparece en puntosRuta)
    // - Waypoints: Puntos 0 al (n-2) de puntosRuta - estos se pueden reordenar
    // - Destino: Último punto (n-1) de puntosRuta - este se mantiene fijo al final

    const ultimoIndex = this.puntosRuta.length - 1;
    const puntosWaypoints = this.puntosRuta.slice(0, ultimoIndex); // Todos menos el último
    const puntoDestino = this.puntosRuta[ultimoIndex]; // El último punto (destino fijo)

    // 1. Reordenar los waypoints según waypoint_order
    waypointOrder.forEach((originalWaypointIndex, newPosition) => {
      if (puntosWaypoints[originalWaypointIndex]) {
        const punto = { ...puntosWaypoints[originalWaypointIndex] };

        // Asignar letra según la nueva posición en la ruta optimizada
        // Como el punto de origen (empresa) no está en puntosRuta, las letras empiezan desde B
        const letra = alphabet[newPosition + 1] || (newPosition + 2).toString();
        const prioridad = this.beaches_rutas[originalWaypointIndex][4] || 0;
        const color = prioridad > 0 ? 'FF0000' : '0066CC';

        punto.iconUrl = `https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=${letra}|${color}`;
        punto.prioridad = prioridad; // Asegurar que la prioridad se mantenga

        puntosReordenados.push(punto);
        console.log(`✅ Waypoint ${newPosition + 1} (${letra}): ${punto.direccion} - Prioridad: ${prioridad} - Índice original: ${originalWaypointIndex}`);
      }
    });

    // 2. Agregar el destino al final (siempre la última letra)
    if (puntoDestino) {
      const puntoDestinoFinal = { ...puntoDestino };
      const letraDestino = alphabet[puntosReordenados.length + 1] || (puntosReordenados.length + 2).toString();
      const prioridadDestino = this.beaches_rutas[ultimoIndex][4] || 0;
      const colorDestino = prioridadDestino > 0 ? 'FF0000' : '0066CC';

      puntoDestinoFinal.iconUrl = `https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=${letraDestino}|${colorDestino}`;
      puntoDestinoFinal.prioridad = prioridadDestino; // Asegurar que la prioridad se mantenga

      puntosReordenados.push(puntoDestinoFinal);
      console.log(`✅ Destino (${letraDestino}): ${puntoDestinoFinal.direccion} - Prioridad: ${prioridadDestino}`);
    }

    // Actualizar el array con el orden optimizado
    this.puntosRuta = puntosReordenados;
    console.log('✅ Puntos reordenados correctamente');
    console.log('Orden final:', this.puntosRuta.map((p, i) => `${alphabet[i]}: ${p.direccion}`));

    // Actualizar la información de puntos duplicados en el footer con las letras correctas
    this.actualizarPuntosDuplicadosFooter();
  }

  // Función para actualizar la información de puntos duplicados en el footer
  private actualizarPuntosDuplicadosFooter() {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    // Limpiar el array de puntos duplicados
    this.puntosDuplicados = [];

    // Agrupar puntos duplicados por dirección
    const puntosDuplicadosPorDireccion = new Map<string, any[]>();

    // Recorrer los puntos y agrupar por dirección
    this.puntosRuta.forEach((punto, index) => {
      const direccion = punto.direccion;

      if (!puntosDuplicadosPorDireccion.has(direccion)) {
        puntosDuplicadosPorDireccion.set(direccion, []);
      }

      puntosDuplicadosPorDireccion.get(direccion).push({
        punto: punto,
        index: index
      });
    });

    // Para cada dirección con múltiples puntos, mostrar todas las letras
    puntosDuplicadosPorDireccion.forEach((puntosEnDireccion, direccion) => {
      if (puntosEnDireccion.length > 1) {
        // Ordenar por índice para obtener las letras en orden
        puntosEnDireccion.sort((a, b) => a.index - b.index);

        // Obtener todas las letras de los puntos duplicados
        // Como el punto de origen (empresa) no está en puntosRuta, las letras empiezan desde B
        const letras = puntosEnDireccion.map(p => alphabet[p.index + 1] || (p.index + 2).toString());

        // Crear el texto de letras (ej: "B = G" o "B = C = D")
        let textoLetras = letras[0];
        for (let i = 1; i < letras.length; i++) {
          textoLetras += ` = ${letras[i]}`;
        }

        // Consolidar información de todos los puntos en esta dirección
        const numerosDocumento = puntosEnDireccion.map(p => p.punto.numerosDocumento).join(', ');
        const cantidadTotal = puntosEnDireccion.length;

        this.puntosDuplicados.push({
          letra: textoLetras,
          direccion: direccion,
          cantidad: cantidadTotal,
          numerosDocumento: numerosDocumento
        });

        console.log(`✅ Punto duplicado: ${textoLetras} - ${direccion} (${cantidadTotal} docs)`);
      }
    });

    console.log('✅ Información de puntos duplicados actualizada en footer:', this.puntosDuplicados);
  }

  // Función para obtener todos los documentos en la misma dirección
  obtenerDocumentosEnMismaDireccion(direccion: string): any[] {
    return this.puntosRuta.filter(punto => punto.direccion === direccion);
  }

  onMapReadyShowRutas(map) {
    console.log('🗺️ Inicializando mapa de rutas...');

    // Limpiar DirectionsRenderer previo si existe y no es el mismo mapa
    if (this.directionsRenderer && this.directionsRenderer.getMap() !== map) {
      try {
        this.directionsRenderer.setMap(null);
      } catch (error) {
        console.warn('⚠️ Error limpiando DirectionsRenderer previo:', error);
      }
    }

    this.globalMap_rutas = map;
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressInfoWindows: true,  // Deshabilitar InfoWindows automáticos
      suppressMarkers: false      // Mantener marcadores automáticos
    });
    this.directionsRenderer.setMap(map);

    console.log('✅ Mapa de rutas inicializado');
  }

  calculateAndDisplayRoute(directionsService, directionsRenderer) {
    let param = {};
    // Usar origen personalizado si está disponible (para rutas divididas), sino usar la empresa
    let paramOrigin;
    if (this.origenPersonalizado) {
      // El origen personalizado es un array [direccion, lat, lng, ...]
      // Para rutas 2, 3, etc., usar el punto inicial de esa ruta (continuidad)
      paramOrigin = `${Number(this.origenPersonalizado[1])}, ${Number(this.origenPersonalizado[2])}`;
      console.log(`🗺️ Calculando ruta desde origen personalizado: ${this.origenPersonalizado[0]} (${paramOrigin})`);
    } else {
      // Para ruta 1, usar la bodega/distribuidor donde se carga el camión
      paramOrigin = `${Number(this.latitudEmpresa)}, ${Number(this.longitudEmpresa)}`;
      console.log(`🗺️ Calculando ruta desde bodega: ${paramOrigin}`);
    }

    if (this.beaches_rutas.length == 1) {
      let paramdest = this.beaches_rutas[0][1] + ',' + this.beaches_rutas[0][2];

      param = {
        origin: paramOrigin, //casa matriz
        destination: paramdest,
        optimizeWaypoints: true,
        travelMode: google.maps.TravelMode.DRIVING,
      };
    } else if (this.beaches_rutas.length > 1) {
      // Enfoque mejorado: usar algoritmo de optimización de rutas más inteligente

      // 1. Crear todos los waypoints sin predeterminar el destino
      const waypts = [];
      const allDestinations = [];

      // Recopilar todas las coordenadas
      this.beaches_rutas.forEach((element, index) => {
        const destination = element[1] + ',' + element[2];
        allDestinations.push({
          location: destination,
          coordinates: { lat: parseFloat(element[1]), lng: parseFloat(element[2]) },
          index: index,
          originalData: element,
          prioridad: element[4] || 0  // La prioridad está en el índice 4
        });
      });

      // 2. Verificar si hay documentos con prioridad > 0
      // Usar origen personalizado si está disponible, sino usar la empresa
      let origin;
      if (this.origenPersonalizado) {
        origin = { lat: Number(this.origenPersonalizado[1]), lng: Number(this.origenPersonalizado[2]) };
      } else {
        origin = { lat: Number(this.latitudEmpresa), lng: Number(this.longitudEmpresa) };
      }
      const hayPrioridades = allDestinations.some(dest => dest.prioridad > 0);
      this.hayPrioridadesEnRuta = hayPrioridades; // Guardar para uso en el callback

      let optimizedDestinations;

      if (hayPrioridades) {
        // 3a. Si hay prioridades, optimizar respetando las prioridades
        console.log('=== DETECTADAS PRIORIDADES - OPTIMIZANDO RESPETANDO PRIORIDADES ===');
        optimizedDestinations = this.optimizeRouteWithPriorities(allDestinations, origin);
      } else {
        // 3b. Si no hay prioridades (todos en 0), optimizar usando el algoritmo del vecino más cercano
        console.log('=== NO HAY PRIORIDADES - OPTIMIZANDO POR DISTANCIA ===');
        optimizedDestinations = this.optimizeRouteOrder(allDestinations, origin);
      }

      // Debug: mostrar el orden optimizado
      this.debugRouteOrder(allDestinations, optimizedDestinations, origin);

      // 4. Reordenar los puntos según la optimización
      this.reordenarPuntosSegunOptimizacion(optimizedDestinations);

      // 5. Usar el enfoque optimizado: todos como waypoints menos el último
      if (optimizedDestinations.length >= 2) {
        // Tomar todos menos el último como waypoints
        for (let i = 0; i < optimizedDestinations.length - 1; i++) {
          waypts.push({
            location: optimizedDestinations[i].location,
            stopover: true
          });
        }

        // El último punto será el destino final
        const finalDestination = optimizedDestinations[optimizedDestinations.length - 1].location;

        param = {
          origin: paramOrigin,
          destination: finalDestination,
          waypoints: waypts,
          optimizeWaypoints: !hayPrioridades, // Si hay prioridades, NO optimizar. Si no hay prioridades, SÍ optimizar
          travelMode: google.maps.TravelMode.DRIVING,
        };
      } else {
        // Fallback: si solo hay 2 puntos, usar el más lejano como destino
        waypts.push({
          location: optimizedDestinations[0].location,
          stopover: true
        });

        param = {
          origin: paramOrigin,
          destination: optimizedDestinations[1].location,
          waypoints: waypts,
          optimizeWaypoints: !hayPrioridades,
          travelMode: google.maps.TravelMode.DRIVING,
        };
      }
    }

    // NO limpiar this.beaches_rutas aquí porque se necesita para el callback
    // this.beaches_rutas.splice(0, this.beaches_rutas.length);

    // Ejecutar la ruta directamente con timeout reducido
    this.routeCalculationTimeout = setTimeout(() => {
      // Limpiar la referencia del timeout ya que se está ejecutando
      this.routeCalculationTimeout = null;

      directionsService.route(param, (response, status) => {
        if (status === 'OK') {
          directionsRenderer.setDirections(response);

          // Solo reordenar si Google Maps optimizó la ruta (cuando no hay prioridades)
          if (response.routes && response.routes[0] && response.routes[0].waypoint_order && !this.hayPrioridadesEnRuta) {
            console.log('🔄 Google Maps optimizó la ruta. Reordenando marcadores...');
            console.log('Orden optimizado de waypoints:', response.routes[0].waypoint_order);
            this.reordenarPuntosSegunRutaOptimizada(response.routes[0].waypoint_order);
          } else if (this.hayPrioridadesEnRuta) {
            console.log('✅ Hay prioridades. Las letras ya fueron asignadas durante la optimización.');
          } else {
            console.log('✅ No hay prioridades y Google Maps no optimizó. Asignando letras...');
            this.asignarLetrasAPuntos();
          }
        } else {
          console.error('Error en el cálculo de ruta:', status);
          this.showError('Ha ocurrido un error al calcular rutas: ' + status);
          this.verRutasCamionModal.hide();
        }
      });
    }, 1000); // Reducir timeout para mejor experiencia de usuario
  }

  showInfo(mensaje) {
    const options = { opacity: 1 };
    this.toastService.info(mensaje, 'Mensaje Información!', options);
  }

  showSuccess(mensaje) {
    const options = { opacity: 1 };
    this.toastService.success(mensaje, 'Mensaje Éxito!', options);
  }

  showError(mensaje) {
    const options = { opacity: 1 };
    this.toastService.error(mensaje, 'Mensaje Error!', options);
  }

  // Función auxiliar para optimizar la ruta usando algoritmo del vecino más cercano
  private optimizeRouteOrder(destinations: any[], origin: { lat: number, lng: number }): any[] {
    if (destinations.length <= 1) return destinations;

    const optimized = [];
    const unvisited = [...destinations]; // Copia del array
    let currentLocation = origin;

    // Algoritmo del vecino más cercano
    while (unvisited.length > 0) {
      let nearestIndex = 0;
      let minDistance = this.calculateDistance(currentLocation, unvisited[0].coordinates);

      // Encontrar el punto más cercano al actual
      for (let i = 1; i < unvisited.length; i++) {
        const distance = this.calculateDistance(currentLocation, unvisited[i].coordinates);
        if (distance < minDistance) {
          minDistance = distance;
          nearestIndex = i;
        }
      }

      // Agregar el punto más cercano a la ruta optimizada
      const nearest = unvisited.splice(nearestIndex, 1)[0];
      optimized.push(nearest);
      currentLocation = nearest.coordinates;
    }

    return optimized;
  }

  // Función para optimizar ruta respetando prioridades
  private optimizeRouteWithPriorities(destinations: any[], origin: { lat: number, lng: number }): any[] {
    if (destinations.length <= 1) return destinations;

    const optimized = [];
    const unvisited = [...destinations]; // Copia del array
    let currentLocation = origin;

    // Primero, procesar todos los puntos con prioridad > 0 en orden de prioridad
    const priorityDestinations = unvisited.filter(dest => dest.prioridad > 0)
      .sort((a, b) => a.prioridad - b.prioridad); // Ordenar por prioridad ascendente (1 es más alta que 2, 3, etc.)

    console.log('Puntos con prioridad encontrados:', priorityDestinations.map(d => `${d.originalData[0]} (prioridad: ${d.prioridad})`));

    // Procesar puntos con prioridad
    for (const priorityDest of priorityDestinations) {
      // Encontrar el índice en el array unvisited
      const index = unvisited.findIndex(dest => dest === priorityDest);
      if (index !== -1) {
        const dest = unvisited.splice(index, 1)[0];
        optimized.push(dest);
        currentLocation = dest.coordinates;
        console.log(`Agregado punto con prioridad: ${dest.originalData[0]} desde ${currentLocation.lat}, ${currentLocation.lng}`);
      }
    }

    // Luego, optimizar el resto de puntos (prioridad 0) usando el algoritmo del vecino más cercano
    console.log(`Puntos restantes sin prioridad: ${unvisited.length}`);

    while (unvisited.length > 0) {
      let nearestIndex = 0;
      let minDistance = this.calculateDistance(currentLocation, unvisited[0].coordinates);

      // Encontrar el punto más cercano al actual
      for (let i = 1; i < unvisited.length; i++) {
        const distance = this.calculateDistance(currentLocation, unvisited[i].coordinates);
        if (distance < minDistance) {
          minDistance = distance;
          nearestIndex = i;
        }
      }

      // Agregar el punto más cercano a la ruta optimizada
      const nearest = unvisited.splice(nearestIndex, 1)[0];
      optimized.push(nearest);
      currentLocation = nearest.coordinates;
      console.log(`Agregado punto sin prioridad: ${nearest.originalData[0]} (distancia: ${minDistance.toFixed(6)})`);
    }

    return optimized;
  }

  // Función para calcular distancia euclidiana entre dos puntos
  private calculateDistance(point1: { lat: number, lng: number }, point2: { lat: number, lng: number }): number {
    const latDiff = point1.lat - point2.lat;
    const lngDiff = point1.lng - point2.lng;
    return Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);
  }

  // Función de debug para verificar el orden optimizado
  private debugRouteOrder(destinations: any[], optimized: any[], origin: { lat: number, lng: number }) {
    console.log('=== DEBUG DE OPTIMIZACIÓN DE RUTA (MODAL) ===');
    console.log('Origen:', origin);
    console.log('Destinos originales:');
    destinations.forEach((dest, index) => {
      console.log(`  ${index + 1}. ${dest.originalData[0]} - Prioridad: ${dest.prioridad} - Lat: ${dest.coordinates.lat}, Lng: ${dest.coordinates.lng}`);
    });
    console.log('Destinos en orden final:');
    optimized.forEach((dest, index) => {
      const distance = this.calculateDistance(
        index === 0 ? origin : optimized[index - 1].coordinates,
        dest.coordinates
      );
      console.log(`  ${index + 1}. ${dest.originalData[0]} - Prioridad: ${dest.prioridad} - Lat: ${dest.coordinates.lat}, Lng: ${dest.coordinates.lng} (distancia: ${distance.toFixed(6)})`);
    });

    // Verificar si hay prioridades
    const hayPrioridades = destinations.some(dest => dest.prioridad > 0);
    console.log(`Hay prioridades definidas: ${hayPrioridades ? 'SÍ' : 'NO'}`);

    if (hayPrioridades) {
      console.log('RESULTADO: Orden optimizado respetando prioridades (puntos con prioridad primero, luego optimización por distancia)');
    } else {
      console.log('RESULTADO: Orden optimizado por distancia');
    }

    // Calcular distancia total de la ruta
    let totalDistance = 0;
    for (let i = 0; i < optimized.length; i++) {
      const from = i === 0 ? origin : optimized[i - 1].coordinates;
      const to = optimized[i].coordinates;
      totalDistance += this.calculateDistance(from, to);
    }
    console.log(`Distancia total de la ruta: ${totalDistance.toFixed(6)}`);
    console.log('================================================');
  }
}
